import { render, staticRenderFns } from "./ScheduleViewSwitch.vue?vue&type=template&id=630b9698&scoped=true"
import script from "./ScheduleViewSwitch.vue?vue&type=script&lang=js"
export * from "./ScheduleViewSwitch.vue?vue&type=script&lang=js"
import style0 from "./ScheduleViewSwitch.vue?vue&type=style&index=0&id=630b9698&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630b9698",
  null
  
)

export default component.exports